export default __webpack_public_path__ + "static/media/pop.64fbbf24.gif";